export default "__VITE_ASSET__Bbh2RArP__"